<script lang="ts">
  import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
  import { faCalendarAlt, faForward } from "@fortawesome/free-solid-svg-icons";
  import Fa from "svelte-fa";
  import { Button, Col, Navbar, NavbarBrand, Row } from "sveltestrap";
import GameOverModal from "../components/GameOverModal.svelte";
  import JournalistsPane from "../components/JournalistsPane.svelte";
  import NextTurnModal from "../components/NextTurnModal.svelte";
  import StarRating from "../components/StarRating.svelte";
  import SubscribersPane from "../components/SubscribersPane.svelte";
  import Tip from "../components/Tip.svelte";
  import { gamestate } from "../stores";

  let isNextTurnModalOpen = false;
</script>

<main class="d-flex flex-column position-absolute top-0 bottom-0 start-0 end-0">
  <Navbar color="dark" dark>
    <NavbarBrand>
      <h1>
        <Fa icon={faNewspaper} class="me-1" />EDITOR-IN-CHIEF
      </h1>
    </NavbarBrand>

    <div class="flex-grow-1" />

    <div class="text-light me-3">
      <Fa icon={faCalendarAlt} />
      DAY {$gamestate.turn + 1}
    </div>

    <Button
      class="sans d-none d-md-inline"
      color="light"
      on:click={() => {
        $gamestate.finishTurn();
        gamestate.update((x) => x);
        isNextTurnModalOpen = true;
      }}
    >
      Finish Turn
      <Fa icon={faForward} />
    </Button>
  </Navbar>

  <GameOverModal isOpen={$gamestate.turn >= $gamestate.END_TURN} />

  <div class="overflow-auto">
    <Row class="m-3">
      <Col>
        <Row class="mb-3">
          <Col>
            <h3 class="sans">Profit</h3>
            <div class="display-4">
              ${($gamestate.money.latest + $gamestate.money.queue).toFixed(2)}
            </div>
          </Col>
          <Col>
            <h3 class="sans">Rating</h3>
            {#if $gamestate.activeHeadlines.length}
              <div class="display-6 mt-3">
                <StarRating stars={$gamestate.rating} />
              </div>
            {:else}
              <div class="display-4">N/A</div>
            {/if}
          </Col>
          <Col>
            <h3 class="sans">Subscribers</h3>
            <div class="display-4">
              {$gamestate.subscribers.length.toLocaleString()}
            </div>
          </Col>
        </Row>

        <h3 class="sans">Journalists</h3>
        <JournalistsPane />

        <h3 class="sans">Audience Interests</h3>
        <SubscribersPane />
      </Col>

      <Col>
        <h3 class="sans">News Tips</h3>
        <Row class="align-items-stretch">
          {#each $gamestate.currentTips as tip}
            <Tip {tip} />
          {/each}
        </Row>
      </Col>
    </Row>
  </div>

  <div class="flex-grow-1" />

  <Navbar color="dark" dark class="d-md-none">
    <Button
      class="sans"
      color="light"
      block
      on:click={() => {
        $gamestate.nextTurn();
        gamestate.update((x) => x);
      }}
    >
      NEXT TURN
      <Fa icon={faForward} />
    </Button>
  </Navbar>
</main>

<NextTurnModal
  isOpen={isNextTurnModalOpen}
  toggle={() => {
    isNextTurnModalOpen = !isNextTurnModalOpen;
    $gamestate.nextTurn();
    gamestate.update((x) => x);
  }}
/>

<style>
  h1 {
    font-size: 1.5em;
    font-weight: 700;
    margin: 0;
  }
</style>
